import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function Register() {
  const { register, error } = useAuth();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const ok = await register(email, password, name);
    setBusy(false);
    if (ok) navigate("/dashboard");
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2">
      <div className="grid place-items-center p-8 order-2 lg:order-1">
        <form onSubmit={onSubmit} className="w-full max-w-md" data-testid="register-form">
          <Link to="/" className="label-mono mb-2 block hover:text-volt">← BACK TO BASE</Link>
          <h1 className="font-display text-4xl font-black mb-2">ENLIST</h1>
          <p className="text-muted-foreground mb-8">Create your operator profile.</p>

          <label className="label-mono block mb-2">Call Sign / Name</label>
          <input
            value={name} onChange={(e) => setName(e.target.value)} required
            className="w-full bg-secondary border border-border px-4 py-3 mb-5 focus:outline-none focus:border-volt"
            data-testid="register-name-input"
          />
          <label className="label-mono block mb-2">Email</label>
          <input
            value={email} onChange={(e) => setEmail(e.target.value)} required type="email"
            className="w-full bg-secondary border border-border px-4 py-3 mb-5 focus:outline-none focus:border-volt"
            data-testid="register-email-input"
          />
          <label className="label-mono block mb-2">Password (min 6)</label>
          <input
            value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} type="password"
            className="w-full bg-secondary border border-border px-4 py-3 mb-6 focus:outline-none focus:border-volt"
            data-testid="register-password-input"
          />

          {error && <div className="border border-destructive text-destructive px-4 py-2 mb-4 text-sm" data-testid="register-error">{error}</div>}

          <button disabled={busy} type="submit" className="w-full bg-volt text-black py-4 font-display uppercase tracking-widest font-bold hover:bg-white disabled:opacity-50" data-testid="register-submit-btn">
            {busy ? "Creating..." : "Create Account"}
          </button>

          <div className="mt-6 text-sm text-muted-foreground">
            Already enlisted? <Link to="/login" className="text-volt hover:underline" data-testid="register-to-login-link">Login</Link>
          </div>
        </form>
      </div>
      <div className="relative hidden lg:block order-1 lg:order-2">
        <img src="https://images.pexels.com/photos/9845041/pexels-photo-9845041.jpeg?auto=compress&cs=tinysrgb&w=1280" alt="" className="w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-l from-background via-background/30 to-transparent"></div>
        <div className="absolute bottom-12 right-12 text-right">
          <div className="label-mono text-volt mb-3">// JOIN THE RANKS</div>
          <h2 className="font-display text-5xl font-black max-w-md leading-none ml-auto">FORGE YOUR PLAN.</h2>
        </div>
      </div>
    </div>
  );
}
